import { Routes, Route } from 'react-router-dom';
import { ProtectedRoute } from '@/components/common/ProtectedRoute';
import { useSelector } from 'react-redux';
import { RootState } from './store';
import { useIsAuthenticated } from './hooks';
import {
  AccountDetails,
  AccountStatement,
  AccountSummary,
  ActivityLog,
  ActivityLogs,
  AffiliateListing,
  AffiliateReq,
  AllDownlineListing,
  Settlement,
  BankerDashboard,
  BankerDetail,
  BannerManagement,
  BetList,
  BetSetting,
  BussinessReports,
  CasinoBetList,
  CasinoControl,
  CasinoDetail,
  CasinoPlByDownline,
  CasinoPlByPlayer,
  CategoryControl,
  ComissionReport,
  AffiliateActiveUserOfWeek,
  ContentManagement,
  DashBoard,
  DashboardPage,
  DWRequest,
  EventManagement,
  Export,
  FilteredGames,
  GameControl,
  InactiveMemerList,
  Login,
  ManageAccount,
  NotFoundPage,
  NotificationManagement,
  OnboardingPage,
  PlByEvent,
  PlByPlayer,
  PlDownline,
  ProviderControl,
  Risk,
  Setting,
  SubUsers,
  SubUsersListing,
  SupportContactManagement,
  TransactionCode,
  TransactionHistory,
  UserAccountStatement,
  UserBetHistory,
  UserBettingPL,
  AuthLayout,
  DashboardLayout,
  RoleWiseAccountStatement,
  BonusStatement,
  PolicyManagement,
} from '@/components/routes';

export function App() {
  // useEffect(() => {
  //   const bankerDomain = import.meta.env.VITE_BANKER_URL;
  //   const adminDomain = import.meta.env.VITE_ADMIN_URL;

  //   if (location.href.includes(bankerDomain)) {
  //     document.title = 'Rebel Exchange Banker';
  //   } else if (location.href.includes(adminDomain)) {
  //     document.title = 'Rebel Exchange Admin/Agent';
  //   }
  // }, []);

  return (
    <Routes>
      {/* Auth Routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
        {/* <Route path="/register" element={<RegisterPage />} /> */}
      </Route>

      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<DashboardLayout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          {/* Downline Routes */}
          <Route path="/members/:id" element={<AllDownlineListing />} />
          <Route path="/settlement" element={<Settlement />} />
          <Route path="/members/:id/:user/:memberid/:upline" element={<SubUsers />} />
          <Route path="/members/:id/sub/:memberid" element={<AccountDetails />}>
            <Route index element={<AccountSummary />} />
            <Route path="account-summary" element={<AccountSummary />} />
            <Route path="account-statement" element={<UserAccountStatement />} />
            <Route path="bet-history" element={<UserBetHistory />} />
            <Route path="betting-pl" element={<UserBettingPL />} />
            <Route path="casino-detail" element={<CasinoDetail />} />

            <Route path="transaction-history" element={<TransactionHistory />} />
            <Route path="login-history" element={<ActivityLog />} />
          </Route>

          {/* Banker Management */}
          <Route path="/bankers/:id/:details?/:mode?/:type?" element={<BankerDetail />} />
          <Route path="/requests/:mode?/:type?" element={<DWRequest />} />
          <Route path="/manage-account/:type?" element={<ManageAccount />} />
          {/* <Route path="/account-statement" element={<AccountStatement />} /> */}
          <Route path="/banker-dashboard" element={<BankerDashboard />} />

          {/* Content Management */}
          <Route path="/content-management" element={<ContentManagement />}>
            <Route index element={<BannerManagement />} />
            <Route path="Notification" element={<NotificationManagement />} />
            <Route path="Contact" element={<SupportContactManagement />} />
          </Route>

          {/* Affiliate Management */}
          {/* <Route path="/affiliate-dashboard" element={<DashBoard />} />
          <Route path="/affiliate-req" element={<AffiliateReq />} />
          <Route path="/affiliate-list" element={<AffiliateListing />} />
          <Route path="/affiliate-list/:id" element={<SubUsersListing />} />
          <Route path="/affiliate-comission-report" element={<ComissionReport />} />
          <Route path="/affiliate-comission-report/:id" element={<AffiliateActiveUserOfWeek />} />
          <Route path="/affiliate-setting" element={<AffiliateSetting />} /> */}

          {/* Casino management */}
          <Route path="/casino-management" element={<CasinoControl />}>
            <Route index element={<CategoryControl />} />
            <Route path="provider" element={<ProviderControl />} />
            <Route path="game" element={<GameControl />} />
          </Route>
          <Route path="/casino-management/games" element={<FilteredGames />} />

          {/* Change Password Routes */}
          <Route path="/settings" element={<Setting />} />

          {/* Event Management*/}
          <Route path="/event-management/:status?" element={<EventManagement />} />
          <Route path="/bet-setting" element={<BetSetting />} />

          {/* Risk Management Routes */}
          <Route path="/risk" element={<Risk />} />

          {/* Reports Routes */}
          <Route path="/bet-list" element={<BetList />} />
          <Route path="/casino-bet-list" element={<CasinoBetList />} />
          <Route path="/pl-by-downline" element={<PlDownline />} />
          <Route path="/pl-by-player" element={<PlByPlayer />} />
          <Route path="/pl-by-event" element={<PlByEvent />} />
          <Route path="/casinopl-by-player" element={<CasinoPlByPlayer />} />
          <Route path="/casinopl-by-downline" element={<CasinoPlByDownline />} />
          <Route path="/activity-logs" element={<ActivityLogs />} />
          <Route path="/inactive-members" element={<InactiveMemerList />} />
          <Route path="/business-reports" element={<BussinessReports />} />

          {/* Export History */}
          <Route path="/export" element={<Export />} />

          {/* Account statement */}
          <Route path="/account-statement" element={<RoleWiseAccountStatement />} />
          {/* Bonus Management */}
          <Route path="/bonus">
            <Route path="policy-management" element={<PolicyManagement />} />
            <Route path="statement" element={<BonusStatement />} />
          </Route>
        </Route>
      </Route>
      {/* </Route> */}
      <Route path="/transaction-code" element={<TransactionCode />} />

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
